<template>
    <section class="row mt-2 mt-lg-5 section-products" id="sectionProducts">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <h1 class="section-title">Sản phẩm</h1>
                    </div>
                </div>
            </div>
            <div class="row mt-0 mt-lg-3">
                <div class="col-10 offset-1 col-lg-4 offset-lg-4">
                    <div class="slider-products-name">
                        <span class="product-name" v-for="(itemValue, itemIndex) in this.productsSliderItemsList" :key="'item' + itemIndex">{{ itemValue.title }}</span>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-lg-8 offset-lg-2">
                    <div class="slider-products-image">
                        <img :src="assetsBaseUrl + itemValue.filePath" v-for="(itemValue, itemIndex) in this.productsSliderItemsList" :key="'item' + itemIndex">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-8 offset-lg-2">
                    <div class="slider-products-description">
                        <blockquote class="blockquote text-center" v-for="(itemValue, itemIndex) in this.productsSliderItemsList" :key="'item' + itemIndex">
                            {{ itemValue.description }}
                        </blockquote>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /**
     * Import helpers
     */
    import {
        createProductsDescriptionSlider,
        createProductsImageSlider,
        createProductsNameSlider
    } from '../helpers/slick';

    export default {
        name: "ProductsComponent",
        data() {
            return {
                assetsBaseUrl: process.env.VUE_APP_API_DOMAIN + process.env.VUE_APP_ASSETS_PATH + '/',
                productsSliderItemsList: null
            }
        },
        mounted() {
            // get top-slider items list
            this.productsSliderItemsList = this.$store.state.sliders.productsSlider.itemsList;

            /**
             * Create products slider
             */
            $(document).ready(function() {
                createProductsNameSlider();
                createProductsImageSlider();
                createProductsDescriptionSlider();
            })
        }
    }
</script>

<style scoped>

</style>
